module.exports = __webpack_public_path__ + "static/media/Benifits2.4b5e54a5.png";